import type {
	Pixels,
	Percentage,
} from '@atlassian/jira-software-deployments-common-table/src/types';
import type { FutureInfo, PastInfo } from './index';

const scrollLeftToPercentage = (scrollLeft: Pixels, scrollWidth: Pixels): Percentage =>
	(scrollLeft / scrollWidth) * 100;

const scrollRightToPercentage = (scrollRight: Pixels, scrollWidth: Pixels): Percentage =>
	(scrollRight / scrollWidth) * 100;

const invertLeftOrRightPercentage = (leftOrRight: Percentage): Percentage => 100 - leftOrRight;

export const getPastIndicatorInfo = (
	latestDeploymentRight: Percentage,
	scrollLeft: Pixels,
	scrollWidth: Pixels,
): PastInfo | null => {
	const scrollLeftPercentage = scrollLeftToPercentage(scrollLeft, scrollWidth);

	if (invertLeftOrRightPercentage(latestDeploymentRight) <= scrollLeftPercentage) {
		return {
			scrollTo: invertLeftOrRightPercentage(latestDeploymentRight),
			left: scrollLeftPercentage,
		};
	}

	return null;
};

export const getFutureIndicatorInfo = (
	oldestDeploymentLeft: Percentage,
	scrollRight: Pixels,
	scrollWidth: Pixels,
): FutureInfo | null => {
	const scrollRightPercentage = scrollRightToPercentage(scrollRight, scrollWidth);

	if (invertLeftOrRightPercentage(oldestDeploymentLeft) <= scrollRightPercentage) {
		return {
			scrollTo: oldestDeploymentLeft,
			right: scrollRightPercentage,
		};
	}

	return null;
};
